angular
  .module('linshare.directives')
  .directive('autoFocus', autoFocus);

autoFocus.$inject = ['$timeout'];

function autoFocus($timeout){
  return {
    restrict: 'A',
    link : function($scope, $element) {
      $timeout(function() {
        $element[0].focus();
      });
    }
  };
};